export default __webpack_public_path__ + "static/media/DCL_A01.cdcad7aa.mp4";